import { render, staticRenderFns } from "./ProfileChangeNickname.vue?vue&type=template&id=9d13b2ca&scoped=true"
import script from "./ProfileChangeNickname.vue?vue&type=script&lang=js"
export * from "./ProfileChangeNickname.vue?vue&type=script&lang=js"
import style0 from "./ProfileChangeNickname.vue?vue&type=style&index=0&id=9d13b2ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d13b2ca",
  null
  
)

export default component.exports